import { render, staticRenderFns } from "./LeftDataCom.vue?vue&type=template&id=119c8bf4&scoped=true"
import script from "./LeftDataCom.vue?vue&type=script&lang=js"
export * from "./LeftDataCom.vue?vue&type=script&lang=js"
import style0 from "./LeftDataCom.vue?vue&type=style&index=0&id=119c8bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119c8bf4",
  null
  
)

export default component.exports